import PropTypes from 'prop-types';
import React from 'react';
import uniqueId from 'lodash/uniqueId';
import { compose, withProps, lifecycle, withState } from 'recompose';
import classnames from 'classnames';

const CheckboxButton = ({
  label,
  checkedLabel,
  onChange,
  onClick,
  checked,
  disabled,
  children,
  value,
  name,
  id,
  onBlur,
  small,
  type,
}) => (
  <div className={classnames('c-checkbox-button', { 'c-checkbox--small': small })}>
    <input
      className="c-checkbox-button__input"
      type={type}
      disabled={disabled}
      checked={checked}
      id={id}
      value={value}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      onClick={onClick}
    />
    <label
      className="c-checkbox-button__label" htmlFor={id}
    >
      <span className="c-checkbox-button__trigger" />
      <span
        className="c-checkbox-button__text"
        display-if={label || children}
      >
        {checked ? checkedLabel : label || children}
      </span>
    </label>
  </div>
);

CheckboxButton.propTypes = {
  label: PropTypes.string,
  checkedLabel: PropTypes.string,
  children: PropTypes.node,
  onChange: PropTypes.func,
  onClick: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  onBlur: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string, // eslint-disable-line react/require-default-props
  small: PropTypes.bool,
  type: PropTypes.string,
};

CheckboxButton.defaultProps = {
  type: 'checkbox',
  label: '',
  checkedLabel: '',
  children: null,
  onChange: () => null,
  onClick: () => null,
  onBlur: () => null,
  checked: null,
  disabled: false,
  value: '',
  name: '',
  small: false,
};

export default compose(
  withState('generatedId', 'setGeneratedId', ''),
  lifecycle({
    componentWillMount() {
      if (!this.props.id) {
        this.props.setGeneratedId(uniqueId('checkbox-'));
      }
    },
  }),
  withProps(props => ({
    id: props.id || props.generatedId,
  })),
)(CheckboxButton);
